<template>
  <v-dialog v-model="dialog" width="800" v-if="!changesItem.empty">
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="perso_card"
        v-bind="attrs"
        v-on="on"
        width="100%"
        flat
        @click="load"
      >
        <v-container class="fill-height">
          <v-row class="mx-4">
            <v-col>
              <v-row>
                <v-col>
                  <h3 class="text-left text-h6">
                    {{ $t("changes.update") }} {{ dateStr(changesItem.date) }}
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <p class="text-left text-body-1 my-0">
                    <span class="perso_hero">{{ changesItem.nb_rules }}</span>
                    {{ $t("changes.rules") }}
                  </p>
                  <p class="text-left text-body-1 my-0" style="height: 50px">
                    <span class="perso_hero">{{ changesItem.nb_sub }}</span>
                    {{ $t("changes.substances") }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
    <!-- pop up -->
    <v-card>
      <v-card-title class="white--text text-h5 primary">
        {{ $t("changes.update") }} {{ dateStr(changesItem.date) }}
      </v-card-title>
      <v-container fluid>
        <v-row class="mx-2 my-1" v-if="dialogloading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
        <v-row class="mx-2 my-1" v-else>
          <v-col>
            <v-row v-if="changesItem.nb_rules > 0">
              <v-col>
                <h1 class="text-h5">{{ $t("changes.rulesConcern") }} :</h1>
                <div class="many overflow-y-auto">
                  <ul class="px-2 py-2">
                    <li
                      v-for="(rule, a) in content.rules"
                      :key="a"
                      class="text-subtitle-1"
                    >
                      <div
                        @click="goToRule(rule, rule.theme)"
                        style="cursor: pointer"
                      >
                        <v-icon x-small color="primary"> mdi-text-box </v-icon>
                        {{ rule.usual_name }}
                      </div>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="changesItem.nb_sub > 0">
              <v-col>
                <h1 class="text-h5">{{ $t("changes.subsConcern") }} :</h1>
                <div class="many overflow-y-auto">
                  <ul class="px-2 py-2">
                    <li v-for="(substance, a) in content.substances" :key="a">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-content
                            class="py-1"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <div
                              @click="goToSub(substance.id)"
                              style="cursor: pointer"
                            >
                              <v-icon x-small color="primary">
                                mdi-palette
                              </v-icon>
                              {{ substance.usual_name }}
                            </div>
                          </v-list-item-content>
                        </template>
                        <span>
                          <div v-if="substance.rules.length">
                            <p class="my-0 text-body-1">
                              {{ $t("changes.rulesFavConcern") }}
                            </p>
                            <ul>
                              <li v-for="(rule, c) in substance.rules" :key="c">
                                {{ rule.usual_name }}
                              </li>
                            </ul>
                          </div>
                          <div v-else>
                            <p class="my-0 text-body-1">
                              {{ $t("changes.noRulesConcern") }}
                            </p>
                          </div>
                        </span>
                      </v-tooltip>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          {{ $t("generic.Close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-card class="perso_card" width="100%" flat v-else>
    <v-container class="fill-height">
      <v-row class="mx-4">
        <v-col>
          <v-row>
            <v-col>
              <h3 class="text-left text-h6">
                {{ $t("changes.update") }} {{ dateStr(changesItem.date) }}
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-4">
              <p class="text-left text-body-1 my-0">
                {{ $t("changes.empty") }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
.perso_card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* border: 1px solid rgba(202, 5, 56, 0.4); */
}
.perso_hero {
  color: #ca0538;
  font-size: 24px;
}

/* ul {
  list-style: none;
} */
.many {
  max-height: 150px;
}
</style>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      dialogloading: false,
      content: [],
    };
  },
  props: {
    changesItem: Object,
  },
  methods: {
    ...mapMutations(["setLastPage"]),
    dateStr(date) {
      if (date) {
        const newdate = new Date(date);
        return newdate.toLocaleDateString("fr-FR");
      } else {
        return "";
      }
    },
    goToRule(rule, theme) {
      this.$router.push({
        name: "SearchRules",
        params: {
          rule: { id: rule._id, origin: rule.from, name: rule.usual_name },
          theme: theme,
        },
      });
    },
    goToSub(id) {
      this.setLastPage({
        name: this.$route.name,
      });
      this.$router.push({
        name: "ShowSubstances",
        params: { id: id },
      });
    },
    async load() {
      this.content = [];
      this.dialogloading = true;
      try {
        let url = "/customchanges";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            rules: this.changesItem.data.rulesconcern,
            substances: this.changesItem.data.subsconcern,
          },
        });
        this.content = response.data;
        this.dialogloading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>